<template>
    <div id="status_prototypes" class="x_scrollable">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="status_prototype in status_prototypes"
                    :key="status_prototype.identity"
                    :object="status_prototype"
                    :title="status_prototype.name"
                    :title_link="{name: 'edit_status_prototype', params: {identity: status_prototype.identity}}"
                    :sub_title="status_prototype.scope"
                    :is_show_column="true"
                    :keys="['material_class_name']"
                    :i_18n_key="'status_prototypes'"
                >
                </DataCard>

                <div v-if="!is_loading && status_prototypes.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui compact celled table">
                <thead class="center aligned">
                    <tr>
                        <th>Scope</th>
                        <th>{{ $t('models.attributes.status_prototypes.name') }}</th>
                        <th>{{ $t('models.attributes.status_prototypes.material') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="6">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <StatusPrototype v-for="status_prototype in status_prototypes" :key="status_prototype.identity" :status_prototype="status_prototype">
                    </StatusPrototype>
                </tbody>
            </table>

            <Paginator
                :total_pages="total_pages"
                :current_page="current_page"
                >
            </Paginator>
        </div>
    </div>
</template>

<script>
import StatusPrototype from "../.components/index/item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import DataCard from '@toolbox/data_card/main.vue'

export default {
    name: "StatusPrototypesIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            status_prototypes: [],
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.status_prototypes_module
        },
        pagination() {
            return this.current_store.pagination
        },
        current_page() {
            return this.current_store.pagination.current_page
        },
        total_pages() {
            return this.current_store.pagination.total_pages
        },
        search_params() {
            return this.current_store.search_params
        },
        show_filter() {
            return this.current_store.show_filter
        }
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
        this.search_params.page = 1
        this.pagination.current_page = 1
    },
    watch: {
        '$route': {
            handler(to, from) {
                var page = to.query.page
                if (page) {
                    this.search_params.page = Number(page)
                    this.pagination.current_page = Number(page)
                    this.$store.commit('provider/status_prototypes_module/set_current_page', page)
                    this.fetch_status_prototypes()
                }
            },
            immediate: true,
        },
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_status_prototypes()
                await new Promise(resolve => {
                    this.is_initialized = true
                    this.$noty.information(
                        this.$t("ui.page_titles.status_prototypes") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                this.$noty.error(e)
            } finally {

            }
        },
        fetch_status_prototypes() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_status_prototypes).parse(
                {},
                "?" + object_to_query(this.search_params)
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.status_prototypes = _.orderBy(response.data.status_prototypes, ['scope', 'name'], ['asc', 'asc'])
                        this.$store.commit('provider/status_prototypes_module/set_current_page', response.data.pagination.current_page)
                        this.$store.commit('provider/status_prototypes_module/set_total_pages', response.data.pagination.total_pages)
                    } else {
                        console.log(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error('取得status_prototypes失敗')
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
    },
    components: {
        StatusPrototype,
        ErrorMessages,
        Paginator,
        DataCard,
    }
}
</script>
